import './Button.css';
import React from "react";

export default function Button({ placeholder, type = 'submit', onClick, disabled, variant = 'primary' }) {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`app-button app-button--${variant}`}
        >
            {placeholder}
        </button>
    );
}
